import { IconType, Modal } from '@spotted-zebra-uk/ui-components';
import styles from './TestletsAdjustmentNotificationModal.module.scss';

type TestletsAdjustmentNotificationModalProps = {
  onContinue: () => void;
  onCancel: () => void;
};

export const TestletsAdjustmentNotificationModal = ({
  onContinue,
  onCancel,
}: TestletsAdjustmentNotificationModalProps) => {
  return (
    <Modal
      isOpen
      onClose={onCancel}
      headerIconType={IconType.WARNING}
      header="Testlets will be adjusted for score validity"
      className={styles.modal}
      buttonsProps={{
        onCancelButtonClick: onCancel,
        onConfirmButtonClick: onContinue,
      }}
    >
      <div className={styles.main}>
        <p className={styles.paragraph}>
          One or more cognitive ability stage actions have fewer testlets than
          the minimum required for the In-depth package.
        </p>
        <p className={styles.paragraph}>
          If you continue, the testlet count for those abilities will be
          automatically increased to meet the minimum and ensure score validity.
        </p>
      </div>
    </Modal>
  );
};
